// export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
// export const REGISTER_FAIL = "REGISTER_FAIL";
// export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
// export const LOGIN_FAIL = "LOGIN_FAIL";
// export const LOGOUT = "LOGOUT";

// export const SET_MESSAGE = "SET_MESSAGE";
// export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
// export const SET_APP_LANGUAGE = "SET_APP_LANGUAGE";

export enum ActionType {
  REGISTER_SUCCESS = "REGISTER_SUCCESS",
  REGISTER_FAIL = "REGISTER_FAIL",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGIN_FAIL = "LOGIN_FAIL",
  LOGOUT = "LOGOUT",
  SET_MESSAGE = "SET_MESSAGE",
  CLEAR_MESSAGE = "CLEAR_MESSAGE",
  SET_APP_LANGUAGE = "SET_APP_LANGUAGE",
  UPDATE_USER_ROLES = "UPDATE_USER_ROLES",
  SET_GLOBAL_ALERT = 'SET_GLOBAL_ALERT',
  CLEAR_GLOBAL_ALERT = 'CLEAR_GLOBAL_ALERT',
}
